import axios from "axios"
import router from "@/router";

// 创建请求
const request = axios.create({
  baseURL: 'https://api.jkb100.com',
  timeout: 5000
})

// 添加请求拦截器
request.interceptors.request.use(function (config) { // 在发送请求之前做些什么
  config.headers['Content-Type'] = (config.method === 'get' || config.method === 'GET') ? 'application/x-www-form-urlencoded' : 'application/json';
  if (localStorage.getItem('token')) {
    config.headers['User-Token'] = localStorage.getItem('token');
  }
  return config;
}, function (error) { // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
request.interceptors.response.use(function (response) { // 对响应数据做点什么
  if (response.status === 200) {
    // 未登录删除缓存并跳转登录页
    if (response.data.errno === 100) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      router.replace('/login')
    }
    // 没有权限跳回首页
    if (response.data.errno === 200) {
      router.back()
    }
    // 未设置密码
    if (response.data.errno === 130) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    }
    return response.data;
  }
}, function (error) { // 对响应错误做点什么
  return Promise.reject(error);
});

export default request